import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Badges = Record<string, number>;
const Ctx = createContext<{ badges: Badges; set: (b: Badges) => void }>({ badges: {}, set: () => {} });

export function BadgesProvider({ children }: { children: ReactNode }) {
  const [badges, setState] = useState<Badges>({});
  return <Ctx.Provider value={{ badges, set: (b) => setState((prev) => ({ ...prev, ...b })) }}>{children}</Ctx.Provider>;
}

/** An app publishes its live nav counts (e.g. disputes needing a response); zero hides the badge. */
export function useNavBadges(b: Badges) {
  const { set } = useContext(Ctx);
  const key = JSON.stringify(b);
  useEffect(() => { set(b); }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}

export const useBadgeState = () => useContext(Ctx).badges;
